angular.module('iqxCore')
.controller('actionDialogCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, LanguageSvc, $timeout,  $q) {
	$scope.itemHeadline = false
	$scope.itemAlert = false
	$scope.itemWarning = false
	$scope.actionView = ""


	if ($scope.actiondialogparams.type=='Vacancy') {
		$scope.$close()
		FormSvc.alert("Sorry", "There are no actions available for vacancies", "info")
	}

	$scope.openGoogleMaps=function(addressObj){
		var addr = addressObj.addr1 + "+" + addressObj.addr2 + "+" + addressObj.addr3 + "+" + addressObj.town + "+" + addressObj.postcode
		window.open('http://maps.google.com/?q='+addr, '_blank')
	}

	$scope.favouritesToggle=function(){
		var data={}
		return ApiSvc.fetch($scope,{fetchAPI:'callresult/NetOwnerGetFavTitles',fetchTarget:'FavHeadings',multiRow:true})
		.then(function(){
			FormSvc.modalForm($scope,'manageFavourites',data,'md',{label:'col-sm-3', data:'col-sm-7'},$scope.tags)
			.then(function(data){
				$scope.FavHeadings=[]
				if (data.manageFavs) { // we are dealing with adding something to the favs
					var type
					switch($scope.actiondialogparams.type){
						case 'Company':
							type="C"
						break
						case 'Contacts':
							type="E"
						break
						case 'Person':
							type="P"
						break
					}

					return ApiSvc.fetch($scope,{
						fetchAPI:'call/NetOwnerAddToFavs?pParent='+data.manageFavs+'&pLinkID='+$scope.actiondialogparams.linkID+'&pType='+type,
						fetchTarget:'addToFavs',
						multiRow:false
					})
					.then(function(){
						FormSvc.alert("Success", $scope.itemSummary.name + " was added to your favourites successfully.", "success")
						$scope.getFavouriteStatus()
					})
				}

				if (data.removeFavs && data.removeFavs == 'y') { // we are deleting from the favs! - but make sure they said yes!
				    var args=args || {}
				    return ApiSvc.fetch($scope,{fetchAPI:'call/NetOwnerRemoveFromFavs?FavID='+$scope.isFav.favid,fetchTarget:'removedFromFavs',multiRow:false})
					.then(function(){
						FormSvc.alert("Success", $scope.itemSummary.name + " was removed from your favourites successfully.", "success")
						$scope.getFavouriteStatus()
					})
				}
			})
		})
	}

	$scope.set_actionView = function(view, viewTitle){
		$scope.viewTitle = viewTitle
		if($scope.actionView != view){
			$scope.actionViewLoading = true
			$scope.actionView = ""
			$scope.actionView = view
		}
	}

	$scope.goBack = function(){
		if($scope.actionView && $scope.actionView!=='' && $scope.isMobile){
			$scope.actionView = ''
		}else{
			$scope.$close()
		}
	}

	$scope.quickActions = []

	$scope.getFavouriteStatus=function(){
		return ApiSvc.fetch($scope,{fetchAPI:'callresult/NetOwnerIsFav?pLinkID='+$scope.actiondialogparams.linkID, fetchTarget:'isFav',multiRow:false})
		.then(function(){
			if ($scope.isFav.favid) {
				$scope.favIcon='fas fa-star'
				$scope.FavText=LanguageSvc.lang.ActionDialog.favourites.remove
			} else {
				$scope.favIcon='far fa-star'
				$scope.FavText=LanguageSvc.lang.ActionDialog.favourites.add
			}

		})
	}

	$scope.navItems = []

	$scope.navItems.push({
	  title:"Make Contact",
	  count:"",
	  icon:"fa-phone",
	  url:"views/actionDialog.makeContact.html",
	})
	$scope.navItems.push({
		title:"Details",
		count:"",
		icon:"fa-info",
		url:"views/actionDialog.details.html"
	})
	// only add Department Questions if it is a candidate (type = Person)
	if($scope.actiondialogparams.type == "Person"){
		$scope.navItems.push({
			title:"Department Questions",
			count:"",
			icon:"fa-question-circle",
			url:"views/actionDialog.departmentQuestions.html",
		})
	}
	$scope.navItems.push({
		title:"Make Contact Event",
		count:"",
		icon:"fa-plus",
		url:"views/actionDialog.makeContactEvent.html"
	})
	$scope.navItems.push({
		title:"View Contact Events",
		count:"",
		icon:"fa-list",
		url:"views/actionDialog.viewEventLog.html",
	})
	$scope.navItems.push({
		title:"Make Appointment",
		count:"",
		icon:"fa-calendar-plus",
		url:"views/actionDialog.makeAppointment.html",
	})
	// only add diary if it is a candidate (type = Person)
	if($scope.actiondialogparams.type == "Person"){
		$scope.navItems.push({
			title:"View Availability",
			count:"",
			icon:"fa-calendar",
			url:"views/actionDialog.diary.html",
		})
	}
	// only add diary if it is a Company (type = Company)
	if($scope.actiondialogparams.type == "Company"){
		$scope.navItems.push({
			title:"Placements",
			count:"",
			icon:"fa-briefcase",
			url:"views/actionDialog.placements.html",
		})
	}
	$scope.navItems.push({
		title:"Documents",
		count:"",
		icon:"fa-file",
		url:"views/actionDialog.viewDocuments.html",
	})

  // only progress history if it is a candidate (type = Person)
	if($scope.actiondialogparams.type === "Person"){
    $scope.navItems.push({
      title:"Progress History",
      count:"",
      icon:"fa-history",
      url:"views/actionDialog.progressHistory.html",
    })
	}




	return ApiSvc.fetch($scope,{fetchAPI:'callresult/NetActionDialogGetDetails?pTheID='+$scope.actiondialogparams.linkID+'&pActionDialogType='+$scope.actiondialogparams.type, fetchTarget:'itemSummary',multiRow:false})
	.then(function(){
		$scope.actionViewLoading = true
		if($scope.isMobile){
			$scope.viewTitle = ''
			$scope.actionView = ""
		}else{
			$scope.actionView = "views/actionDialog.makeContact.html"
			$scope.viewTitle = 'Make Contact'
		}
		$scope.getFavouriteStatus()
	})
})
